export default {
  'secure_iframe_loading': '安全嵌入加载中...',
  'secure_iframe_error_title': '嵌入页面加载失败',
  'secure_iframe_error_logged_out': '主站登录已失效，请回到主站重新登录',
  'secure_iframe_error_no_permission': '当前账号无权访问此报表',
  'secure_iframe_error_not_found': '该报表不存在，或未配置为可嵌入第三方',
  'secure_iframe_error_internal': '加载出错，请刷新重试',
  'secure_iframe_retry_btn': '重试',
};
